import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemsService } from '../../../../services/items.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { GovernoratesService } from '../../../../services/governorates.service';
import { Governorate } from '../../../../interfaces/governorate';
import { isEmpty, Observable } from 'rxjs';
import { City } from '../../../../interfaces/city';
import { LanguageServiceService } from '../../../../services/language-service.service';
import { DatePipe, formatDate, Location } from '@angular/common';
import { Item } from '../../../../interfaces/item';
import { EditItemService } from '../../../../services/edit-item.service';
import * as Tesseract from 'tesseract.js'
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { UserService } from '../../../../services/user';
import { BrandService } from '../../../../services/brandservice';
import { WarehouseTypeService } from '../../../../services/warehouse-type';

type AddItemMode = 'new' | 'existing';
const IMAGE_BASE_URL = 'https://backendproduction.blueboxpet.com/storage/app/public/';

const CATEGORY_NAMES: Record<string, string> = {
  '0': 'soft food', '1': 'soft food can', '2': 'dry food', '3': 'bird food',
  '4': 'medicine', '5': 'supplement', '6': 'accessories', '7': 'toy',
  '8': 'grooming', '9': 'house', '10': 'care', '11': 'treats',
  '12': 'training pads', '13': 'bags', '14': 'cleaning tools', '15': 'litter'
};

const SYSTEM_PRODUCT_CATEGORIES = Object.entries(CATEGORY_NAMES).map(([id, label]) => ({ id, label }));

const PET_NAMES: Record<string, string> = {
  '0': 'cats', '1': 'dogs', '2': 'birds', '3': 'other', '4': 'cats&dogs'
};

const PET_TYPE_NAMES: Record<string, string> = {
  '0': 'adult', '1': 'kitten', '2': 'sterilized', '3': 'persian',
  '4': 'puppy', '5': 'birds', '6': 'other'
};

@Component({
  selector: 'app-additem',
  templateUrl: './additem.component.html',
  styleUrl: './additem.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AdditemComponent {
  name_en!: string;
  name_ar!: string;
  warehouses!: any;
  warehouseId!: any;
  contentReady: boolean = false;
  weight!: string;
  type!: string;
  quantity!: string;
  expiration_data!: Date | string;
  price!: string;
  sku!: string;
  isActive = true;
  pricea!: string;
  pricec!: string;
  priceb!: string;

  category_id!: number;
  affiliationprice!: string;
  itemId!: string;
  hasToken: boolean = false;
  data!: FormGroup;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  itemData!: any;
  isUpdatePage = false;
  locationById: any;
  text: any;
  isMobile: boolean = false;
  isAr: boolean = false;
  isAdmin!: boolean;
  accountType!: string;
  today = new Date().toISOString().split('T')[0];
  barcode!: string;
  pet!: any;
  pet_type!: any;
  brands: any[] = [];
  brand_id: number | null = null;
  isClone!: boolean;
  product_info_en!: string;
  product_info_ar!: string;
  warehouseIsStore: boolean = false;
  tags: string = '';
  tagsArray: string[] = [];
  submitted = false;
  addMode: AddItemMode = 'existing';
  systemProducts: any[] = [];
  availableSystemProducts: any[] = [];
  systemProductsCategoryId: string = '';
  readonly systemProductCategories = SYSTEM_PRODUCT_CATEGORIES;
  systemProductsSearch = '';
  productsDropdownOpen = true;
  selectedSystemProductId: string = '';
  selectedSystemProductIds: string[] = [];
  selectedSystemProducts: any[] = [];
  selectedSystemProduct: any = null;
  loadingSystemProducts = false;
  loadingMoreSystemProducts = false;
  selectingAllSystemProducts = false;
  systemProductsPage = 1;
  systemProductsLastPage = 1;
  readonly systemProductsPerPage = 10;

  showExpirationCalendar: boolean = false;
  expirationCalendarViewDate: Date = new Date();

  constructor(
    private router: Router,
    private _ItemsService: ItemsService,
    private fb: FormBuilder,
    private _userService: UserService,
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    public warehouseTypeService: WarehouseTypeService,
    private _brands: BrandService
  ) { }

  token = localStorage.getItem('token');

  ngOnInit() {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") == "ar";
    this.warehouseId = localStorage.getItem("posId");

    this.initiate();
    this.configureProductFieldsForMode();
    this.ensureDefaultSystemProductsCategory();
    this.getWareHouses();
    this.getAllBrands();
    this.loadSystemProductsForWarehouse();

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";

        this.updateWarehouseContext();

      },
      error: (error) => console.error(error),
    });

    this.route.queryParams.subscribe(params => {

      if (!this.isEmpty(params)) {
        if (params["isClone"]) {
          this.isClone = true;
        } else {
          this.isUpdatePage = true;
        }
      }

      this.itemId = params["id"];
      this.name_en = params["name_en"];
      this.name_ar = params["name_ar"];
      this.weight = params["weight"];

      this.sku = params["sku"];
      this.brand_id = params["brand_id"];
      this.barcode = params["barcode"];
      this.product_info_en = params["product_info_en"];
      this.product_info_ar = params["product_info_ar"];
      this.expiration_data = params["expiration_data"];
      this.quantity = params["quantity"];
      this.price = params["price"] ? Number(params["price"]).toString() : '';
      this.pricea = params["pricea"] ? Number(params["pricea"]).toString() : '';
      this.priceb = params["priceb"] ? Number(params["priceb"]).toString() : '';
      this.pricec = params["pricec"] ? Number(params["pricec"]).toString() : '';
      this.affiliationprice = params["affiliationprice"];
      this.category_id = params["category_id"];
      this.tags = params["tags"];
      this.pet = params["pet"];
      this.pet_type = params["pet_type"];

      if (this.tags) {
        if (Array.isArray(params["tags"])) {
          params["tags"].forEach((e: string) => {
            this.tagsArray.push(e);
          });
        } else if (typeof params["tags"] === 'string') {
          this.tagsArray = params["tags"]
            .split(',')
            .map((e: string) => e.trim())
            .filter((e: string) => e);
        }
      }

      const formattedExpirationDate = params["expiration_data"]
        ? this.normalizeDateValue(params["expiration_data"])
        : '';

      this.data.patchValue({
        warehouse: this.warehouseId || '',
        name_en: this.name_en || '',
        name_ar: this.name_ar || '',
        product_info_en: this.product_info_en || '',
        product_info_ar: this.product_info_ar || '',
        tags: this.tagsArray.join(','),
        quantity: this.quantity || '',
        weight: this.weight || '',
        category_id: this.category_id ?? '',
        pet: this.pet ?? '',
        pet_type: this.pet_type ?? '',
        brand_id: this.brand_id ?? '',
        sku: this.sku || '',
        barcode: this.barcode || '',
        price: this.price || '',
        pricea: this.pricea || '',
        priceb: this.priceb || '',
        pricec: this.pricec || '',
        affiliationprice: this.affiliationprice || '',
        expiration_data: formattedExpirationDate
      });

      if (this.isUpdatePage || this.isClone) {
        this.addMode = 'new';
        this.productsDropdownOpen = false;
        this.clearSelectedSystemProduct(false);
        this.configureProductFieldsForMode();
      }

      this.syncExpirationCalendarView();
    });
  }

  onlyNumbers(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    value = value.replace(/[٠١٢٣٤٥٦٧٨٩]/g, (d: string) =>
      '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString()
    );

    value = value.replace(/[^0-9]/g, '');

    if (value.length > 6) {
      value = value.slice(0, 6);
    }

    input.value = value;
  }

  addTags() {
    if (!this.tags.trim()) return;

    const newTags = this.tags
      .split(',')
      .map(tag => tag.trim())
      .filter(tag => tag.length > 0 && !this.tagsArray.includes(tag));

    this.tagsArray.push(...newTags);
    this.tags = '';

    this.data.patchValue({ tags: this.tagsArray.join(',') });
  }

  removeTag(tag: string) {
    this.tagsArray = this.tagsArray.filter(t => t !== tag);
    this.data.patchValue({ tags: this.tagsArray.join(',') });
  }

  shouldShowError(controlName: string): boolean {
    const control = this.data?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  getErrorMessage(controlName: string, label: string): string {
    const control = this.data?.get(controlName);

    if (!control || !control.errors) {
      return '';
    }

    if (control.errors['required']) {
      return this.isAr ? `${label} مطلوب` : `${label} is required`;
    }

    if (control.errors['minlength']) {
      const requiredLength = control.errors['minlength'].requiredLength;
      return this.isAr
        ? `${label} لازم يكون ${requiredLength} حروف على الاقل`
        : `${label} must be at least ${requiredLength} characters`;
    }

    if (control.errors['pattern']) {
      if (['price', 'pricea', 'priceb', 'pricec', 'affiliationprice', 'quantity'].includes(controlName)) {
        return this.isAr
          ? `${label} لازم يكون رقم من 1 الى 6 ارقام`
          : `${label} must be a number from 1 to 6 digits`;
      }

      if (controlName === 'expiration_data') {
        return this.isAr
          ? `${label} لازم يكون تاريخ صحيح`
          : `${label} must be a valid date`;
      }
    }

    return this.isAr ? `${label} غير صحيح` : `${label} is invalid`;
  }

  getMissingRequiredCount(): number {
    if (!this.data) {
      return 0;
    }

    return Object.keys(this.data.controls).filter((controlName) => {
      const control = this.data.get(controlName);
      return control?.hasError('required');
    }).length;
  }

  isEmpty(obj: any): boolean {
    return !obj || Object.keys(obj).length === 0;
  }

  getAllBrands() {
    this._brands.getAllBrands().subscribe({
      next: (res) => {
        this.brands = res;
      },
      error: (err) => {

      },
    });
  }

  getWareHouses() {
    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.warehouses = res.warehouse;
      },
      error: (err) => {

      },
    });
  }

  onWarehouseChange(warehouseId: any): void {
    this.warehouseId = warehouseId;
    this.data.patchValue({ warehouse: warehouseId || '' }, { emitEvent: false });
    this.updateWarehouseContext();
    this.clearSelectedSystemProduct();

    if (this.addMode === 'existing') {
      this.ensureDefaultSystemProductsCategory();
      this.productsDropdownOpen = true;
      this.loadSystemProductsForWarehouse();
    }
  }

  setAddMode(mode: AddItemMode): void {
    if (this.isUpdatePage) return;

    const hadSelectedSystemProduct = !!this.selectedSystemProduct;
    this.addMode = mode;
    this.submitted = false;
    this.clearSelectedSystemProduct(mode === 'existing' || hadSelectedSystemProduct);
    this.configureProductFieldsForMode();

    if (mode === 'existing') {
      this.ensureDefaultSystemProductsCategory();
      this.productsDropdownOpen = true;
      this.loadSystemProductsForWarehouse();
    } else {
      this.productsDropdownOpen = false;
    }
  }

  onSystemProductChange(productId: string): void {
    const product = this.availableSystemProducts.find(
      item => String(item.id) === String(productId)
    );

    if (product) {
      this.toggleSystemProduct(product);
    }
  }

  toggleProductsDropdown(): void {
    if (!this.systemProductsCategoryId) {
      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'اختار الكاتيجوري الأول' : 'Select category first',
        confirmButtonText: this.isAr ? 'تمام' : 'OK'
      });
      return;
    }

    this.productsDropdownOpen = !this.productsDropdownOpen;

    if (this.productsDropdownOpen && this.availableSystemProducts.length === 0 && !this.loadingSystemProducts) {
      this.loadSystemProductsForWarehouse();
    }
  }

  onSystemProductsCategoryChange(categoryId: any): void {
    this.systemProductsCategoryId = String(categoryId ?? '');
    this.clearSelectedSystemProduct(false);

    if (this.addMode === 'existing') {
      this.loadSystemProductsForWarehouse();
    }
  }

  isSystemProductsCategorySelected(categoryId: any): boolean {
    return String(categoryId) === this.systemProductsCategoryId;
  }

  closeProductsDropdown(): void {
    this.productsDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (!target.closest('.bb-existing-products-field')) {
      this.closeProductsDropdown();
    }
  }

  get displayedSystemProducts(): any[] {
    const query = this.cleanComparableValue(this.systemProductsSearch);

    if (!query) {
      return this.availableSystemProducts;
    }

    return this.availableSystemProducts.filter(product =>
      this.getProductSearchText(product).includes(query)
    );
  }

  onSystemProductsSearchChange(): void {
    if (!this.systemProductsSearch.trim()) return;

    if (
      this.systemProductsPage < this.systemProductsLastPage &&
      !this.loadingSystemProducts &&
      !this.loadingMoreSystemProducts
    ) {
      this.loadMoreSystemProducts();
    }
  }

  toggleSystemProduct(product: any): void {
    const productId = String(product?.id ?? '');
    if (!productId) return;

    if (this.isSystemProductSelected(product)) {
      this.selectedSystemProducts = this.selectedSystemProducts.filter(
        item => String(item.id) !== productId
      );
    } else {
      this.selectedSystemProducts = [...this.selectedSystemProducts, product];
    }

    this.syncSelectedSystemProducts();
  }

  toggleAllSystemProducts(): void {
    if (this.areAllSystemProductsSelected()) {
      this.selectedSystemProducts = [];
      this.syncSelectedSystemProducts();
      return;
    }

    this.loadAllSystemProductsAndSelect();
  }

  onSystemProductsScroll(event: Event): void {
    const target = event.target as HTMLElement;
    const distanceFromBottom = target.scrollHeight - target.scrollTop - target.clientHeight;

    if (distanceFromBottom <= 80) {
      this.loadMoreSystemProducts();
    }
  }

  isSystemProductSelected(product: any): boolean {
    return this.selectedSystemProductIds.includes(String(product?.id));
  }

  areAllSystemProductsSelected(): boolean {
    return this.availableSystemProducts.length > 0 &&
      this.systemProductsPage >= this.systemProductsLastPage &&
      this.availableSystemProducts.every(product => this.isSystemProductSelected(product));
  }

  getSelectedProductsCount(): number {
    return this.selectedSystemProducts.length;
  }

  shouldShowStockForm(): boolean {
    return this.addMode !== 'existing' || this.getSelectedProductsCount() === 1;
  }

  getProductDisplayName(product: any): string {
    if (!product) return '';
    return this.isAr
      ? (product.name_ar || product.name_en || '')
      : (product.name_en || product.name_ar || '');
  }

  getSelectedProductSummary(): string {
    if (!this.selectedSystemProduct) return '';

    const parts = [
      this.getProductDisplayName(this.selectedSystemProduct),
      this.selectedSystemProduct.weight,
      this.selectedSystemProduct.barcode ? `${this.isAr ? 'باركود' : 'Barcode'}: ${this.selectedSystemProduct.barcode}` : ''
    ].filter(Boolean);

    return parts.join(' - ');
  }

  getCategoryName(categoryId: any): string {
    return CATEGORY_NAMES[String(categoryId)] ?? '-';
  }

  getPetName(pet: any): string {
    return PET_NAMES[String(pet)] ?? '-';
  }

  getPetTypeName(petType: any): string {
    return PET_TYPE_NAMES[String(petType)] ?? '-';
  }

  getProductImage(product: any): string {
    const image = product?.image || product?.image_url || product?.media?.[0]?.original_url;
    if (!image) return '/assets/noproduct.png';
    if (String(image).startsWith('http')) return image;
    return IMAGE_BASE_URL + image;
  }

  onProductImageError(event: Event): void {
    const image = event.target as HTMLImageElement;
    image.src = '/assets/noproduct.png';
  }

  createSku(str: any, str1: any, str2: any) {
    let result;
    result = str.split("")[0] + str1.split("")[0] + str2.split("")[0];

    return result;
  }

  initiate() {
    this.data = this.fb.group({
      name_ar: ['', [Validators.required, Validators.minLength(2)]],
      system_product_id: [''],
      name_en: ['', [Validators.required, Validators.minLength(2)]],
      barcode: [''],
      product_info_en: [''],
      product_info_ar: [''],
      brand_id: [''],
      weight: ['', [
        Validators.required
      ]],

      tags: [''],
      warehouse: ['', Validators.required],
      pet: [''],
      sku: [''],
      pet_type: [''],
      expiration_data: ['', [
        Validators.required,
        Validators.pattern(/^\d{4}-\d{2}-\d{2}$/)
      ]],
      price: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{1,6}$/)
      ]],

      pricea: ['', Validators.pattern(/^[0-9]{1,6}$/)],
      priceb: ['', Validators.pattern(/^[0-9]{1,6}$/)],
      pricec: ['', Validators.pattern(/^[0-9]{1,6}$/)],
      affiliationprice: ['', Validators.pattern(/^[0-9]{1,6}$/)],
      quantity: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{1,6}$/)
      ]],
      category_id: ['', Validators.required]
    });
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  dataForm: any;

  appendPostDtata() {
    this.dataForm = new FormData();
    this.dataForm.append('name_en', this.name_en);
    this.dataForm.append('name_ar', this.name_ar);
    this.dataForm.append('weight', this.weight);
    this.dataForm.append('product_info_en', this.product_info_en);
    this.dataForm.append('product_info_ar', this.product_info_ar);

    this.dataForm.append('category_id', this.category_id.toString());

    if (this.isUpdatePage)
      this.dataForm.append('sku', this.sku);
    else
      this.dataForm.append('sku', this.createSku(this.name_en, this.barcode, this.warehouseId));

    this.dataForm.append('warehouse_id', this.warehouseId);
    this.dataForm.append('quantity', this.quantity);
    this.dataForm.append('expiration_data', this.data.get('expiration_data')?.value || '');
    this.dataForm.append('price', this.price);

    if (this.pricea || this.priceb || this.pricec || this.affiliationprice) {
      this.dataForm.append('pricea', this.pricea);
      this.dataForm.append('pricec', this.pricec);
      this.dataForm.append('priceb', this.priceb);
      this.dataForm.append('affiliationprice', this.affiliationprice);
    }

    this.tagsArray.forEach(tag => {
      this.dataForm.append('tags[]', tag);
    });

    if (this.brand_id)
      this.dataForm.append('brand_id', this.brand_id);

    this.dataForm.append('barcode', this.barcode);
    this.dataForm.append('pet', this.pet);
    this.dataForm.append('pet_type', this.pet_type);

    if (this.addMode === 'existing' && this.selectedSystemProductId) {
      this.dataForm.append('source_product_id', this.selectedSystemProductId);
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.addMode === 'existing') {
      this.data.patchValue({
        system_product_id: this.selectedSystemProductIds.join(',')
      }, { emitEvent: false });
      this.data.get('system_product_id')?.updateValueAndValidity();
    }

    if (this.data.invalid) {
      this.data.markAllAsTouched();

      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'تأكد من البيانات' : 'Please check form data',
        text: this.isAr ? 'راجع الرسائل تحت الحقول المطلوبة أو غير الصحيحة' : 'Review the messages below the required or invalid fields',
        confirmButtonText: this.isAr ? 'تمام' : 'OK'
      });

      return;
    }

    this.contentReady = true;

    this.appendPostDtata();

    if (this.isUpdatePage)
      this.onUpdate();
    else
      this.onAdd();
  }

  onAdd() {
    if (this.addMode === 'existing' && this.selectedSystemProducts.length > 0) {
      this.onAddExistingProducts();
      return;
    }

    this._ItemsService.createItem(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم اضافة منتج" : 'product created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;

        if (this.isMobile)
          this.router.navigateByUrl('/Home.moblie');
        else
          this.router.navigateByUrl('/Home');
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل حفط المتنج" : 'product not created',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });

        this.contentReady = false;
      },
    });
  }

  onAddExistingProducts() {
    const body = this.buildExistingProductsPayload();

    this._ItemsService.addExistingProductsToWarehouse(body).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم إضافة المنتجات" : 'products created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;

        if (this.isMobile)
          this.router.navigateByUrl('/Home.moblie');
        else
          this.router.navigateByUrl('/Home');
      },
      error: () => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل حفظ المنتجات" : 'products not created',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });

        this.contentReady = false;
      },
    });
  }

  private buildExistingProductsPayload(): Record<string, any> {
    const body: Record<string, any> = {
      warehouse_id: this.warehouseId,
      product_ids: this.selectedSystemProductIds
    };

    if (this.selectedSystemProductIds.length === 1) {
      body['quantity'] = this.data.get('quantity')?.value ?? 0;
      body['expiration_data'] = this.data.get('expiration_data')?.value || this.today;
      body['price'] = this.data.get('price')?.value ?? 0;
      body['pricea'] = this.data.get('pricea')?.value ?? 0;
      body['priceb'] = this.data.get('priceb')?.value ?? 0;
      body['pricec'] = this.data.get('pricec')?.value ?? 0;
      body['affiliationprice'] = this.data.get('affiliationprice')?.value ?? 0;
    }

    return body;
  }

  onUpdate() {
    this._ItemsService.editItem(this.dataForm, this.itemId).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل منتج" : 'product changed',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;

        if (this.isMobile)
          this.router.navigateByUrl('/Home.mobile');
        else
          this.router.navigateByUrl('/Home');
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "لما يتم تعديل منتج" : 'product not changed',
          showConfirmButton: false,
          timer: 1500,
        });
      },
    })
  }

  /* ================================
     Expiration Calendar
     نفس Calendar بتاع New Booking
     ================================ */

  toggleExpirationCalendar(): void {
    this.showExpirationCalendar = !this.showExpirationCalendar;

    if (this.showExpirationCalendar) {
      const selectedDate = this.parseDateOnly(this.data.get('expiration_data')?.value);
      const baseDate = selectedDate || this.parseDateOnly(this.today) || new Date();

      this.expirationCalendarViewDate = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        1
      );
    }
  }

  closeExpirationCalendar(): void {
    this.showExpirationCalendar = false;
  }

  previousExpirationCalendarMonth(): void {
    this.expirationCalendarViewDate = new Date(
      this.expirationCalendarViewDate.getFullYear(),
      this.expirationCalendarViewDate.getMonth() - 1,
      1
    );
  }

  nextExpirationCalendarMonth(): void {
    this.expirationCalendarViewDate = new Date(
      this.expirationCalendarViewDate.getFullYear(),
      this.expirationCalendarViewDate.getMonth() + 1,
      1
    );
  }

  getExpirationCalendarTitle(): string {
    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      month: 'long',
      year: 'numeric',
    }).format(this.expirationCalendarViewDate);
  }

  getExpirationCalendarWeekDays(): string[] {
    return this.isAr
      ? ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
      : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  }

  getExpirationCalendarDays(): Array<{
    date: Date;
    dayNumber: string;
    isCurrentMonth: boolean;
    isToday: boolean;
    isSelected: boolean;
    isDisabled: boolean;
  }> {
    const year = this.expirationCalendarViewDate.getFullYear();
    const month = this.expirationCalendarViewDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const gridStart = new Date(year, month, 1 - firstDay.getDay());

    const today = this.parseDateOnly(this.today) || new Date();
    today.setHours(0, 0, 0, 0);

    const selectedDate = this.parseDateOnly(this.data.get('expiration_data')?.value);

    return Array.from({ length: 42 }, (_, index) => {
      const date = new Date(gridStart);
      date.setDate(gridStart.getDate() + index);
      date.setHours(0, 0, 0, 0);

      return {
        date,
        dayNumber: this.isAr ? this.toArabicDigits(date.getDate()) : String(date.getDate()),
        isCurrentMonth: date.getMonth() === month,
        isToday: this.isSameDate(date, today),
        isSelected: selectedDate ? this.isSameDate(date, selectedDate) : false,
        isDisabled: date < today
      };
    });
  }

  selectExpirationCalendarDate(date: Date): void {
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    const today = this.parseDateOnly(this.today) || new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate < today) return;

    this.data.patchValue({
      expiration_data: this.formatDateForInput(selectedDate)
    });

    this.data.get('expiration_data')?.markAsTouched();
    this.data.get('expiration_data')?.updateValueAndValidity();

    this.closeExpirationCalendar();
  }

  getExpirationDateDisplay(): string {
    const date = this.parseDateOnly(this.data?.get('expiration_data')?.value);

    if (!date) {
      return this.isAr ? 'اختار تاريخ الانتهاء' : 'Select expiration date';
    }

    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  }

  private syncExpirationCalendarView(): void {
    const selectedDate = this.parseDateOnly(this.data?.get('expiration_data')?.value);
    const baseDate = selectedDate || this.parseDateOnly(this.today) || new Date();

    this.expirationCalendarViewDate = new Date(
      baseDate.getFullYear(),
      baseDate.getMonth(),
      1
    );
  }

  private normalizeDateValue(value: any): string {
    if (!value) return '';

    const parsedDate = this.parseDateOnly(value);
    if (parsedDate) {
      return this.formatDateForInput(parsedDate);
    }

    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) {
      return this.formatDateForInput(date);
    }

    return String(value);
  }

  private parseDateOnly(value: any): Date | null {
    if (!value) return null;

    const cleanValue = String(value)
      .replace('T', ' ')
      .replace('Z', '')
      .split('.')[0]
      .trim()
      .split(' ')[0];

    const match = cleanValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) return null;

    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3])
    );
  }

  private isSameDate(first: Date, second: Date): boolean {
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
  }

  private formatDateForInput(date: Date): string {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-');
  }

  private toArabicDigits(value: string | number): string {
    return String(value).replace(/\d/g, (digit) => '٠١٢٣٤٥٦٧٨٩'[Number(digit)]);
  }

  private updateWarehouseContext(): void {
    this.warehouseIsStore = false;

    if (!this.warehouseId) return;

    this._userService.getWarehouseType(Number(this.warehouseId)).subscribe({
      next: (data) => {
        this.warehouseIsStore = data['warehouses_type'] == "1";
      },
      error: () => {
        this.warehouseIsStore = false;
      }
    });
  }

  private configureProductFieldsForMode(): void {
    const productFields = [
      'name_ar',
      'name_en',
      'barcode',
      'product_info_en',
      'product_info_ar',
      'brand_id',
      'weight',
      'tags',
      'pet',
      'sku',
      'pet_type',
      'category_id'
    ];

    productFields.forEach(field => {
      const control = this.data.get(field);
      if (!control) return;

      if (this.addMode === 'existing') {
        control.disable({ emitEvent: false });
      } else {
        control.enable({ emitEvent: false });
      }
    });

    const systemProductControl = this.data.get('system_product_id');
    if (this.addMode === 'existing') {
      systemProductControl?.setValidators([Validators.required]);
    } else {
      systemProductControl?.clearValidators();
    }
    systemProductControl?.updateValueAndValidity({ emitEvent: false });
    this.configureStockFieldsForMode();
  }

  private configureStockFieldsForMode(): void {
    const shouldRequireStockData = this.shouldShowStockForm();
    const requiredStockFields = ['quantity', 'price', 'expiration_data'];
    const optionalPriceFields = ['pricea', 'priceb', 'pricec', 'affiliationprice'];

    requiredStockFields.forEach(field => {
      const control = this.data.get(field);
      if (!control) return;

      if (shouldRequireStockData) {
        control.enable({ emitEvent: false });
        control.setValidators([
          Validators.required,
          field === 'expiration_data'
            ? Validators.pattern(/^\d{4}-\d{2}-\d{2}$/)
            : Validators.pattern(/^[0-9]{1,6}$/)
        ]);
      } else {
        control.clearValidators();
        control.disable({ emitEvent: false });
      }

      control.updateValueAndValidity({ emitEvent: false });
    });

    optionalPriceFields.forEach(field => {
      const control = this.data.get(field);
      if (!control) return;

      if (shouldRequireStockData) {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
      }

      control.setValidators([Validators.pattern(/^[0-9]{1,6}$/)]);
      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  private loadSystemProductsForWarehouse(): void {
    if (!this.warehouseId || this.isUpdatePage || !this.systemProductsCategoryId) {
      this.systemProducts = [];
      this.availableSystemProducts = [];
      this.loadingSystemProducts = false;
      this.loadingMoreSystemProducts = false;
      this.selectingAllSystemProducts = false;
      return;
    }

    this.systemProductsPage = 1;
    this.systemProductsLastPage = 1;
    this.systemProducts = [];
    this.availableSystemProducts = [];
    this.loadingSystemProducts = true;

    this.loadSystemProductsPage(1, true);
  }

  private ensureDefaultSystemProductsCategory(): void {
    if (this.systemProductsCategoryId || this.systemProductCategories.length === 0) {
      return;
    }

    this.systemProductsCategoryId = this.systemProductCategories[0].id;
  }

  private loadMoreSystemProducts(): void {
    if (
      this.loadingSystemProducts ||
      this.loadingMoreSystemProducts ||
      this.systemProductsPage >= this.systemProductsLastPage
    ) {
      return;
    }

    this.loadSystemProductsPage(this.systemProductsPage + 1, false);
  }

  private loadAllSystemProductsAndSelect(): void {
    if (this.selectingAllSystemProducts) {
      return;
    }

    this.selectingAllSystemProducts = true;
    this.loadingSystemProducts = true;
    this.loadingMoreSystemProducts = false;

    const startPage = this.availableSystemProducts.length > 0 ? this.systemProductsPage + 1 : 1;
    this.loadRemainingSystemProductsThenSelect(startPage);
  }

  private loadRemainingSystemProductsThenSelect(page: number): void {
    if (this.availableSystemProducts.length > 0 && this.systemProductsPage >= this.systemProductsLastPage) {
      this.selectAllAvailableSystemProducts();
      return;
    }

    this.getAvailableSystemProductsPage(page).subscribe({
      next: (response) => {
        const pageProducts = this.extractStocks(response);
        this.systemProductsPage = this.extractCurrentPage(response, page);
        this.systemProductsLastPage = this.extractLastPage(response);
        this.systemProducts = page === 1 ? pageProducts : this.mergeProducts(this.systemProducts, pageProducts);
        this.availableSystemProducts = this.systemProducts;

        if (this.systemProductsPage < this.systemProductsLastPage) {
          this.loadRemainingSystemProductsThenSelect(this.systemProductsPage + 1);
          return;
        }

        this.selectAllAvailableSystemProducts();
      },
      error: (error) => {
        console.error(error);
        this.selectingAllSystemProducts = false;
        this.loadingSystemProducts = false;
        this.loadingMoreSystemProducts = false;
      }
    });
  }

  private selectAllAvailableSystemProducts(): void {
    this.selectedSystemProducts = [...this.availableSystemProducts];
    this.syncSelectedSystemProducts();
    this.selectingAllSystemProducts = false;
    this.loadingSystemProducts = false;
    this.loadingMoreSystemProducts = false;
  }

  private loadSystemProductsPage(page: number, reset: boolean): void {
    if (reset) {
      this.loadingSystemProducts = true;
    } else {
      this.loadingMoreSystemProducts = true;
    }

    this.getAvailableSystemProductsPage(page).subscribe({
      next: (response) => {
        const pageProducts = this.extractStocks(response);
        this.systemProductsPage = this.extractCurrentPage(response, page);
        this.systemProductsLastPage = this.extractLastPage(response);
        this.systemProducts = reset ? pageProducts : this.mergeProducts(this.systemProducts, pageProducts);
        this.availableSystemProducts = this.systemProducts;
        this.selectedSystemProducts = this.selectedSystemProducts.filter(selectedProduct =>
          this.availableSystemProducts.some(product => String(product.id) === String(selectedProduct.id))
        );
        this.syncSelectedSystemProducts();
        this.loadingSystemProducts = false;
        this.loadingMoreSystemProducts = false;
      },
      error: (error) => {
        console.error(error);
        if (reset) {
          this.availableSystemProducts = [];
        }
        this.loadingSystemProducts = false;
        this.loadingMoreSystemProducts = false;
      }
    });
  }

  private extractStocks(response: any): any[] {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data)) return response.data;
    if (Array.isArray(response?.stocks?.data)) return response.stocks.data;
    if (Array.isArray(response?.stocks)) return response.stocks;
    if (Array.isArray(response?.stock)) return response.stock;
    if (Array.isArray(response?.items)) return response.items;
    return [];
  }

  private getAvailableSystemProductsPage(page: number): Observable<any> {
    return this._ItemsService.getAvailableSystemProducts(
      this.warehouseId,
      this.systemProductsCategoryId,
      page,
      this.systemProductsPerPage
    );
  }

  private extractCurrentPage(response: any, fallback: number): number {
    return Number(response?.stocks?.current_page ?? response?.current_page ?? response?.data?.current_page ?? fallback);
  }

  private extractLastPage(response: any): number {
    return Number(response?.stocks?.last_page ?? response?.last_page ?? response?.data?.last_page ?? 1);
  }

  private mergeProducts(existingProducts: any[], nextProducts: any[]): any[] {
    const productMap = new Map<string, any>();

    [...existingProducts, ...nextProducts].forEach(product => {
      productMap.set(String(product.id), product);
    });

    return Array.from(productMap.values());
  }

  private cleanComparableValue(value: any): string {
    return String(value ?? '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  private getProductSearchText(product: any): string {
    return [
      product?.name_ar,
      product?.name_en,
      product?.barcode,
      product?.sku,
      ...this.parseTags(product?.tags)
    ].map(value => this.cleanComparableValue(value)).join(' ');
  }

  private applySystemProduct(product: any): void {
    this.name_en = product.name_en || '';
    this.name_ar = product.name_ar || '';
    this.product_info_en = product.product_info_en || '';
    this.product_info_ar = product.product_info_ar || '';
    this.weight = product.weight || '';
    this.category_id = product.category_id ?? '';
    this.pet = product.pet ?? '';
    this.pet_type = product.pet_type ?? '';
    this.brand_id = product.brand_id ?? '';
    this.sku = product.sku || '';
    this.barcode = product.barcode || '';

    this.tagsArray = this.parseTags(product.tags);
    this.tags = '';

    this.data.patchValue({
      system_product_id: product.id,
      name_en: this.name_en,
      name_ar: this.name_ar,
      product_info_en: this.product_info_en,
      product_info_ar: this.product_info_ar,
      tags: this.tagsArray.join(','),
      weight: this.weight,
      category_id: this.category_id,
      pet: this.pet,
      pet_type: this.pet_type,
      brand_id: this.brand_id,
      sku: this.sku,
      barcode: this.barcode
    }, { emitEvent: false });
  }

  private syncSelectedSystemProducts(): void {
    this.selectedSystemProductIds = this.selectedSystemProducts.map(product => String(product.id));
    this.selectedSystemProductId = this.selectedSystemProductIds[0] || '';
    this.selectedSystemProduct = this.selectedSystemProducts[0] || null;

    this.data?.patchValue({
      system_product_id: this.selectedSystemProductIds.join(',')
    }, { emitEvent: false });

    if (this.selectedSystemProduct) {
      this.applySystemProduct(this.selectedSystemProduct);
    } else if (this.addMode === 'existing') {
      this.clearProductMirrorData();
    }

    this.data?.get('system_product_id')?.markAsTouched();
    this.data?.get('system_product_id')?.updateValueAndValidity({ emitEvent: false });
    this.configureStockFieldsForMode();
  }

  private parseTags(tags: any): string[] {
    if (!tags) return [];

    if (Array.isArray(tags)) {
      return tags.map(tag => String(tag).trim()).filter(Boolean);
    }

    if (typeof tags === 'string') {
      try {
        const parsedTags = JSON.parse(tags);
        if (Array.isArray(parsedTags)) {
          return parsedTags.map(tag => String(tag).trim()).filter(Boolean);
        }
      } catch {
        return tags.split(',').map(tag => tag.trim()).filter(Boolean);
      }
    }

    return [];
  }

  private clearSelectedSystemProduct(clearProductData: boolean = this.addMode === 'existing'): void {
    this.selectedSystemProductId = '';
    this.selectedSystemProductIds = [];
    this.selectedSystemProducts = [];
    this.selectedSystemProduct = null;
    this.data?.patchValue({ system_product_id: '' }, { emitEvent: false });

    if (clearProductData) {
      this.clearProductMirrorData();
    }
  }

  private clearProductMirrorData(): void {
    [
      'name_ar',
      'name_en',
      'barcode',
      'product_info_en',
      'product_info_ar',
      'brand_id',
      'weight',
      'tags',
      'pet',
      'sku',
      'pet_type',
      'category_id'
    ].forEach(field => this.data.get(field)?.reset('', { emitEvent: false }));

    this.name_en = '';
    this.name_ar = '';
    this.product_info_en = '';
    this.product_info_ar = '';
    this.weight = '';
    this.category_id = '' as any;
    this.pet = '';
    this.pet_type = '';
    this.brand_id = null;
    this.sku = '';
    this.barcode = '';
    this.tags = '';
    this.tagsArray = [];
  }
}
